import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookCopy, Gift, Star } from 'lucide-react';
import { Section } from './ui/Section';
const stats = [{
  icon: <Users className="w-6 h-6 text-celeste-600" data-id="element-334" />,
  value: '+300',
  label: 'maestras confían',
  bg: 'bg-celeste-50'
}, {
  icon: <BookCopy className="w-6 h-6 text-emerald-600" data-id="element-335" />,
  value: '6',
  label: 'Tomos listos',
  bg: 'bg-emerald-50'
}, {
  icon: <Gift className="w-6 h-6 text-amber-600" data-id="element-336" />,
  value: '6',
  label: 'Bonos incluidos',
  bg: 'bg-amber-50'
}, {
  icon: <Star className="w-6 h-6 text-yellow-500 fill-yellow-500" data-id="element-337" />,
  value: '4.9/5',
  label: 'calificación',
  bg: 'bg-yellow-50'
}];
export const Stats = () => {
  return <Section background="white" className="py-12 md:py-16 border-y border-stone-100" data-id="element-338">
      <div className="text-center mb-8" data-id="element-339">
        <h3 className="text-sm font-bold tracking-widest text-stone-400 uppercase" data-id="element-340">
          Números que hablan
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-341">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="flex flex-col items-center text-center p-4 rounded-2xl hover:bg-stone-50 transition-colors" data-id="element-342">
            <div className={`w-12 h-12 rounded-full ${stat.bg} flex items-center justify-center mb-4`} data-id="element-343">
              {stat.icon}
            </div>
            <div className="text-3xl font-extrabold text-stone-900 mb-1 font-heading" data-id="element-344">
              {stat.value}
            </div>
            <div className="text-sm font-medium text-stone-500" data-id="element-345">
              {stat.label}
            </div>
          </motion.div>)}
      </div>
    </Section>;
};